import styled from "styled-components";

/** Libraries */
import { Checkbox } from "@libraries/mui";

const Container = styled.div``;

const ItemContent = styled.div`
  font-size: 13px;
  .titleHeader {
    font-size: 15px;
    font-weight: 700;
    color: #000;
  }

  .titleContent {
    font-weight: 700;
    color: #000;
  }
`;

const CustomCheckbox = styled(Checkbox)`
  color: ${({ theme }) => theme.colors.primary} !important;
`;

export { Container, ItemContent, CustomCheckbox };
